import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type SizeSettingPresetResponse, SizeSettings } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getPrivateSizePresetsListKey } from '../usePrivateSizePresetsList';

export type UsePrivateSizePresetsCreateMutationParams = NonNullable<Parameters<typeof SizeSettings.Presets.create>[0]>;

export const usePrivateSizePresetsCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UsePrivateSizePresetsCreateMutationParams) => {
      return callAirApi<SizeSettingPresetResponse>(() => SizeSettings.Presets.create(params));
    },

    onError: (error, variables) => {
      reportErrorToBugsnag({
        context: 'Failed to create size preset',
        error,
        metadata: {
          data: variables,
          key: 'data',
        },
      });
    },

    onSettled: async (_data, _error, variables) => {
      await queryClient.invalidateQueries({
        queryKey: getPrivateSizePresetsListKey({ workspaceId: variables.workspaceId }),
      });
    },
  });
};
